export interface SideBar {
    class?: string,
    visible?: boolean
}
